import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import cx from 'classnames2';
import React from 'react';
import { Icon } from '../Icon';
import { ValidationStates } from '../Input';
import styles from './TextArea.scss';

var createOnChangeHandler = function createOnChangeHandler(callback) {
  return function (e) {
    return callback(e.target.value);
  };
};

export var TextArea = function TextArea(props) {
  var _containerClassnames, _textareaClassnames;

  var containerClassnames = (_containerClassnames = {}, _defineProperty(_containerClassnames, styles.errorState, props.validationState === ValidationStates.Error), _defineProperty(_containerClassnames, styles.successState, props.validationState === ValidationStates.Success), _containerClassnames);
  var textareaClassnames = (_textareaClassnames = {}, _defineProperty(_textareaClassnames, styles.disabled, props.disabled), _defineProperty(_textareaClassnames, styles.neutral, props.variant === 'neutral'), _defineProperty(_textareaClassnames, styles.naked, props.variant === 'naked'), _defineProperty(_textareaClassnames, styles.sizeSmall, props.size === 'small'), _defineProperty(_textareaClassnames, styles.sizeDefault, props.size === 'default'), _defineProperty(_textareaClassnames, styles.sizeLarge, props.size === 'large'), _textareaClassnames);
  return React.createElement("div", {
    className: cx(styles.container, containerClassnames)
  }, React.createElement("textarea", {
    className: cx(textareaClassnames),
    id: props.id,
    "data-test": props.dataTest,
    disabled: props.disabled,
    placeholder: props.placeholder,
    rows: props.rowCount,
    value: props.value,
    maxLength: props.maxLength,
    onChange: props.onChange && createOnChangeHandler(props.onChange),
    onBlur: props.onBlur && createOnChangeHandler(props.onBlur),
    onKeyDown: props.onKeyDown,
    onKeyUp: props.onKeyUp
  }), React.createElement("span", {
    className: cx(styles.iconWrapper)
  }, props.validationState === ValidationStates.Success && React.createElement(Icon, {
    className: styles.icon,
    icon: "status-success"
  }), props.validationState === ValidationStates.Error && React.createElement(Icon, {
    className: styles.icon,
    icon: "status-error"
  })));
};
TextArea.defaultProps = {
  variant: 'neutral',
  size: 'default',
  rowCount: 3
};